import { Theme } from '@emotion/react';
import { SxProps } from '@mui/material';
import { GridRowParams } from '@mui/x-data-grid';
import storeConnector from '@src/store/storeConnector';
import { WidgetTypeDeviceList } from '@src/types/Widget';
import { useState } from 'react';
import DeviceDataTable, {
  DeviceDataTableRow,
} from './DeviceDataTable/DeviceDataTable';
import WidgetDeviceRowDetails from './WidgetDeviceRowDetailModal';

function WidgetDeviceList({
  widgetId,
  widgetConfig,
  sx,
  unitControllerId,
  unitControllerEngineeringId,
}: {
  widgetId: string;
  widgetConfig: WidgetTypeDeviceList;
  sx?: SxProps<Theme>;
  unitControllerId?: string;
  unitControllerEngineeringId?: string;
}) {
  const { enableModalDetails } = widgetConfig;
  const [selectedSourceDevice, setSelectedSourceDevice] = useState<{
    name: string;
    id: string;
  } | null>(null);

  return (
    <>
      <DeviceDataTable
        widgetId={widgetId}
        hideFooter
        additionalClassnames='detail-data-table'
        devices={widgetConfig?.devices || []}
        dataPoints={widgetConfig?.dataPoints || []}
        pointConfigRefs={widgetConfig?.pointConfigRefs || []}
        useDualListView={widgetConfig.useDualListView ?? false}
        sx={sx}
        {...(enableModalDetails
          ? {
              onRowClick: ({ row }: GridRowParams<DeviceDataTableRow>) => {
                const { name, id } = row;
                setSelectedSourceDevice({ name, id });
              },
              getRowClassName: () => 'MuiDataGrid-clickable',
            }
          : {})}
      />
      {selectedSourceDevice && (
        <WidgetDeviceRowDetails
          widgetConfigId={widgetConfig.internalId}
          onClose={() => {
            setSelectedSourceDevice(null);
          }}
          selectedSourceDevice={selectedSourceDevice}
          unitControllerId={unitControllerId}
          unitControllerEngineeringId={unitControllerEngineeringId}
        />
      )}
    </>
  );
}

export default storeConnector(WidgetDeviceList, {
  config: ['siteMeta'],
});
